import { useState } from 'preact/hooks';
import type { Sex } from '../../../shared/src/protocol';
import { defaultOutfit } from '../../../shared/src/protocol';
import { VOCATIONS, type VocationId } from '../../../shared/src/game/vocations';
import { normalizeName, validateName } from '../../../shared/src/game/names';
import { api } from '../api';
import { Button, ErrorText, Field, Window } from '../ui';
import { OutfitImage } from './Characters';

const HINT: Record<VocationId, string> = {
  knight: 'hint_03_vocationknight', paladin: 'hint_04_vocationpaladin', sorcerer: 'hint_05_vocationsorcerer',
  druid: 'hint_06_vocationdruid', monk: 'hint_11_vocationmonk',
};

export function CreateCharacter(props: { onDone: () => void; onCancel: () => void }) {
  const [name, setName] = useState('');
  const [sex, setSex] = useState<Sex>('male');
  const [vocation, setVocation] = useState<VocationId>('knight');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: Event) {
    e.preventDefault();
    const n = normalizeName(name);
    const problem = validateName(n);
    if (problem) return setError(problem);
    setBusy(true);
    setError(null);
    try {
      await api.createCharacter({ name: n, sex, vocation });
      props.onDone();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div class="screen center nx-bg">
      <Window title="Criar personagem" width={900}>
        <form onSubmit={submit} class="create">
          <div class="create-left stack">
            <Field label="Nome" value={name} onInput={setName} maxLength={29} autoFocus />
            <div class="tb-field">
              <span>Sexo</span>
              <div class="row">
                <button type="button" class={'sex male ' + (sex === 'male' ? 'on' : '')} onClick={() => setSex('male')} aria-label="Masculino" />
                <button type="button" class={'sex female ' + (sex === 'female' ? 'on' : '')} onClick={() => setSex('female')} aria-label="Feminino" />
              </div>
            </div>
            <div class="tb-field">
              <span>Vocation</span>
              <div class="voc-list">
                {VOCATIONS.map((v) => (
                  <label key={v.id} class={'tb-radio ' + (v.id === vocation ? 'on' : '')}>
                    <input type="radio" name="voc" checked={v.id === vocation} onChange={() => setVocation(v.id)} />
                    <i />
                    {v.name}
                  </label>
                ))}
              </div>
            </div>
            <div class="preview">
              <OutfitImage outfit={defaultOutfit(sex)} scale={2} />
              <span class="muted small">{normalizeName(name) || 'Seu personagem'}</span>
            </div>
          </div>
          <div class="create-right">
            <img src={`/assets/interface/images/tutorial/${HINT[vocation]}.png`} alt={vocation} width={400} height={400} />
          </div>
          <div class="create-bottom">
            <ErrorText error={error} />
            <div class="row end">
              <Button onClick={props.onCancel}>Voltar</Button>
              <Button type="submit" variant="green" disabled={busy}>Criar</Button>
            </div>
          </div>
        </form>
      </Window>
    </div>
  );
}
